import React from "react";
import CheckoutForm from "../components/checkout/checkout";

const Checkout = () => {
    return (
        <div>
            <CheckoutForm />
        </div>
    );
};

export default Checkout;
